module.exports = "<!-- RIBBON -->\r\n<div id=\"ribbon\">\r\n  <ng-template #tipContent><i class=\"text-warning fa fa-warning\"></i> Warning! This will reset all your widget settings.</ng-template>\r\n\r\n  <span class=\"ribbon-button-alignment\">\r\n\t\t\t\t\t<span id=\"refresh\" class=\"btn btn-ribbon\" (click)=\"resetWidgets()\"\r\n                placement=\"bottom\"\r\n                [tooltip]=\"tipContent\">\r\n\t\t\t\t\t\t<i class=\"fa fa-refresh\"></i>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</span>\r\n  <sa-route-breadcrumbs></sa-route-breadcrumbs>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/ribbon/ribbon.component.html
// module id = 916
// module chunks = 85